/**
 * @file This file contains the classes implementing the interfaces defined in the corresponding types file.
 */

import { SchemaTag, type ProcessingRule } from '@sap/ux-specification-types';
import { syncRule } from '../../../common/decoration';
import type * as v2 from '@sap/ux-specification-types/src/v2/genericSchemaHandling/controls/ListHeader';
import { Share } from './Action';

// ListHeaderActions
@syncRule({
    processingRuleAdapter(processingRule: ProcessingRule): void {
        processingRule.element[SchemaTag.icon] = 'Export'; // do not use member of enum UiIcons in @sap-ux/ui-components to avoid unwanted dependency
    }
})
export class ListHeaderActions implements v2.ListHeaderActions {
    // Share
    @syncRule({
        processingRuleAdapter(processingRule: ProcessingRule): void {
            processingRule.referenceAdaptation = {
                syncRuleProvider: Share
            };
        }
    })
    Share?: Share;
}

// ListHeader
@syncRule({
    processingRuleAdapter(processingRule: ProcessingRule): void {
        processingRule.element[SchemaTag.icon] = 'Header'; // do not use member of enum UiIcons in @sap-ux/ui-components to avoid unwanted dependency
    }
})
export class ListHeader implements v2.ListHeader {
    // actions
    @syncRule({
        processingRuleAdapter(processingRule: ProcessingRule): void {
            processingRule.referenceAdaptation = {
                syncRuleProvider: ListHeaderActions
            };
        }
    })
    actions?: ListHeaderActions;
}
